module.exports = __webpack_public_path__ + "static/media/Thunder_Badge.bb14b6f3.png";